import React, { Component } from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
} from 'reactstrap'
import FalconModal from '../../components/Inputs/FalconModal'
import {
  getCoachingBreakSchema,
  getCoachingBreakUiSchema,
  getCoachingLevelSchema,
  getCoachingLevelUiSchema,
} from '../../components/Inputs/dataschemas'
import EditButton from '../../components/Buttons/EditButton'
import DeleteButton from '../../components/Buttons/DeleteButton'


function Levels({ levels, firebase, onChanced }) {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [selected, setSelected] = React.useState(null)
  const [saving, setSaving] = React.useState(false)

  console.log('LEVELS firebase', typeof firebase.createCoachingLevel)
  const deleteLevel = async (levelId) => {
    setSaving(true)
    await firebase.deleteCoachingLevel(levelId)
    onChanced('levels')
    setSaving(false)
  }

  const createLevel = async (level) => {
    setSaving(true)
    await firebase.createCoachingLevel(level)
    onChanced('levels')
    setSaving(false)
  }

  const updateLevel = async (level) => {
    setSaving(true)
    await firebase.updateCoachingLevel(level)
    onChanced('levels')
    setSaving(false)
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <Row>
            <Col lg='10' md='5' sm='5'>
              <CardTitle tag='h5'>
                Tasojärjestelmän tasot (jos käytössä)
              </CardTitle>
            </Col>
            <Col className='text-right'>
              <Button
                color='primary'
                size='sm'
                onClick={() => setDialogOpen(true)}
              >
                Lisää uusi
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <table>
            <thead>
              <tr>
                <th>Lyhenne</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  Kuvaus
                </th>
                <th>Järjestys</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  Toiminnot
                </th>
              </tr>
            </thead>
            <tbody>
              {levels && levels.length > 0 ? (
                levels.map((level) => (
                  <tr key={level.id}>
                    <td
                      style={{ textAlign: 'center', verticalAlign: 'middle' }}
                    >
                      {level.abbr}
                    </td>
                    <td
                      style={{ textAlign: 'center', verticalAlign: 'middle' }}
                    >
                      {level.description}
                    </td>
                    <td
                      style={{ textAlign: 'center', verticalAlign: 'middle' }}
                    >
                      {level.order}
                    </td>
                    <td>
                      <EditButton
                        onClick={() => {
                          setSelected(level)
                          setDialogOpen(true)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Muokkaa
                      </EditButton>
                      {/* <DeleteButton
                        onClick={async () => {
                          await deleteLevel(level.id)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Poista
                      </DeleteButton> */}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>Ei valmennus tasoja</td>
                </tr>
              )}
            </tbody>
          </table>
          {/* <TableContainer>
            <Table
              aria-label='a dense table'
              size='small'
              style={{ minWidth: 650 }}
            >
              <TableBody>
                {levels && levels.length > 0 ? (
                  levels.map((level) => (
                    <TableRow key={level.id} style={{ borderBottom: 'none' }}>
                      <TableCell
                        styles={{
                          borderBottom: 'none',
                          paddingTop: 0,
                          paddingBottom: 0,
                        }}
                      >
                        <Typography
                          onClick={() => {
                            setSelected(level)
                          }}
                          variant='body1'
                          component='span'
                          style={{ marginRight: 20 }}
                        >
                          {level.abbr}
                        </Typography>
                      </TableCell>
                      <TableCell
                        styles={{
                          borderBottom: 'none',
                          paddingTop: 0,
                          paddingBottom: 0,
                        }}
                      >
                        <Typography
                          variant='body1'
                          component='span'
                          style={{ marginRight: 20 }}
                        >
                          {level.description}
                        </Typography>
                      </TableCell>
                      <TableCell
                        styles={{
                          borderBottom: 'none',
                          paddingTop: 0,
                          paddingBottom: 0,
                        }}
                      >
                        <Typography
                          variant='body1'
                          component='span'
                          style={{ marginRight: 20 }}
                        >
                          {level.order}
                        </Typography>
                      </TableCell>
                      <TableCell
                        styles={{
                          borderBottom: 'none',
                          paddingTop: 0,
                          paddingBottom: 0,
                        }}
                      >
                        <EditButton
                          onClick={() => {
                            setSelected(level)
                          }}
                          loading={saving}
                          disablediv={true}
                        >
                          Muokkaa
                        </EditButton>
                        <DeleteButton
                          onClick={async () => {
                            setSaving(true)
                            setSaving(false)
                          }}
                          loading={saving}
                          disablediv={true}
                        >
                          Poista
                        </DeleteButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <p>Ei valmennus tasoja</p>
                )}
              </TableBody>
            </Table>
          </TableContainer> */}
        </CardBody>
      </Card>
      <FalconModal
        isOpen={dialogOpen}
        title='Muokkaa valmennustasoa'
        toggle={() => {
          setSelected(null)
          setDialogOpen(!dialogOpen)
        }}
        onUpdate={updateLevel}
        onCreate={createLevel}
        resource={selected}
        uiSchema={getCoachingLevelUiSchema()}
        dataSchema={getCoachingLevelSchema()}
      />
    </div>
  )
}

function Breaks({ breaks, firebase, onChanced }) {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [selected, setSelected] = React.useState(null)
  const [saving, setSaving] = React.useState(false)

  const deleteBreak = async (breakId) => {
    setSaving(true)
    await firebase.deleteCoachingBreak(breakId)
    onChanced('breaks')
    setSaving(false)
  }

  const createBreak = async (brk) => {
    setSaving(true)
    await firebase.createCoachingBreak(brk)
    onChanced('breaks')
    setSaving(false)
  }

  const updateBreak = async (brk) => {
    setSaving(true)
    await firebase.updateCoachingBreak(brk)
    onChanced('breaks')
    setSaving(false)
  }

  console.log('BREAKS', breaks)

  return (
    <div>
      <Card>
        <CardHeader>
          <Row>
            <Col lg='10' md='5' sm='5'>
              <CardTitle tag='h5'>Valmennuksen tauot</CardTitle>
            </Col>
            <Col className='text-right'>
              <Button
                color='primary'
                size='sm'
                onClick={() => setDialogOpen(true)}
              >
                Lisää uusi
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <table>
            <thead>
              <tr>
                <th>Nimi</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  Alkaa
                </th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  Loppuu
                </th>
                <th>Toiminnot</th>
              </tr>
            </thead>
            <tbody>
              {breaks && breaks.length > 0 ? (
                breaks.map((brk) => (
                  <tr key={brk.id}>
                    <td>{brk.name}</td>
                    <td style={{ paddingLeft: 20, paddingRight: 10 }}>
                      {new Date(Date.parse(brk.start)).toLocaleDateString()}
                    </td>
                    <td style={{ paddingLeft: 20, paddingRight: 10 }}>
                      {new Date(Date.parse(brk.end)).toLocaleDateString()}
                    </td>
                    <td>
                      <EditButton
                        onClick={() => {
                          setSelected(brk)
                          setDialogOpen(true)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Muokkaa
                      </EditButton>
                      <DeleteButton
                        onClick={async () => {
                          await deleteBreak(brk.id)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Poista
                      </DeleteButton>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>Ei valmennuksen taukoja</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* {breaks && breaks.length > 0 ? (
            breaks.map((brk) => (
              <Row key={brk.id}>
                <Col>
                  <Typography variant='h6'>Nimi: {brk.name}</Typography>
                </Col>
              </Row>
            ))
          ) : (
            <p>Ei valmennuksen taukoja</p>
          )} */}
        </CardBody>
      </Card>
      <FalconModal
        isOpen={selected !== null || dialogOpen}
        title='Muokkaa valmennuksen taukoa'
        toggle={() => {
          setSelected(null)
          setDialogOpen(!dialogOpen)
        }}
        onUpdate={updateBreak}
        onCreate={createBreak}
        resource={selected}
        uiSchema={getCoachingBreakUiSchema()}
        dataSchema={getCoachingBreakSchema()}
      />
    </div>
  )
}

class CoachingGeneralSettingsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seasons: [],
      levels: [],
      classes: [],
      breaks: [],
      formEditorOpen: false,
      pricings: [],
      applications: [],
    }
  }

  onChanced = (collection) => {
    if (collection === 'levels') {
      this.props.firebase.getCoachingLevels().then((levels) => {
        this.setState({ levels })
      })
    } else if (collection === 'breaks') {
      this.props.firebase.getCoachingBreaks().then((breaks) => {
        breaks.sort((a, b) => {
          return new Date(Date.parse(a.start)) - new Date(Date.parse(b.start))
        })
        this.setState({ breaks })
      })
    }
  }

  async componentDidMount() {
    console.log('Fetching coaching seasons...')
    const [levels, breaks] =
      await Promise.all([
        this.props.firebase.getCoachingLevels(),
        this.props.firebase.getCoachingBreaks(),
      ])
    breaks.sort((a, b) => {
      return new Date(Date.parse(a.start)) - new Date(Date.parse(b.start))
    })
    this.setState({ levels, breaks })
  }


  render() {
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <Levels
                levels={this.state.levels}
                firebase={this.props.firebase}
                onChanced={this.onChanced}
              />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
              <Breaks
                breaks={this.state.breaks}
                firebase={this.props.firebase}
                onChanced={this.onChanced}
              />
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(CoachingGeneralSettingsContainer)
